import * as React from "react"

import { useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { Button } from "@walmart-web/livingdesign-components"

import { IconWrapper } from "../IconWrapper"
import NewModuleTag from "../NewModuleTag/NewModuleTag"

import "./index.scss"

interface SubmoduleInfoProperties {
	featureFlagId: string
	titleIntlId: string
	descriptionIntlId: string
	iconId: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | string
	url: string
	enabled: boolean
	isNewModule?: boolean
	startDate?: Date
	endDate?: Date
}

const SubmoduleInfo: React.FunctionComponent<SubmoduleInfoProperties> = ({
	titleIntlId,
	descriptionIntlId,
	url,
	iconId,
	enabled,
	isNewModule,
	startDate,
	endDate,
}) => {
	const intl = useIntl()
	const history = useHistory()
	const moduleName = intl.formatMessage({ id: titleIntlId })

	return (
		<div className="submoduleinfo-container">
			<div className="icon">
				<IconWrapper icon={iconId} alt={moduleName} size={48} />
			</div>
			<div className="content">
				<div className="module-title">
					<h1>{moduleName}</h1>

					{isNewModule && (
						<NewModuleTag from={startDate as Date} to={endDate as Date} />
					)}
				</div>

				<p>{intl.formatMessage({ id: descriptionIntlId })}</p>
				<Button
					disabled={!enabled}
					variant="secondary"
					onClick={() => history.push(url)}
				>
					{intl.formatMessage(
						{ id: "phronesis.submodule.button" },
						{ module: moduleName }
					)}
				</Button>
			</div>
		</div>
	)
}

export default SubmoduleInfo
